import { type SVGProps, useState } from "react";

export function SpreaderIcon({ selected = false, ...props }: { selected?: boolean } & SVGProps<SVGSVGElement>) {
  const [hovered, setHovered] = useState(false);

  const hoverFill = "var(--webapp-palette-primary-500)";
  const modeFill = "var(--color-foreground)";

  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
      className={`bottom-bar-icon ${selected ? "selected" : ""} ${props.className ?? ""}`}
      role="img"
      aria-label="Spreader"
    >
      <rect x="7" y="5" width="14" height="18" rx="1" stroke={modeFill} strokeWidth="2" />
      <rect
        x="10.5"
        y="8.5"
        width="7"
        height="2"
        style={{
          fill: hovered ? hoverFill : modeFill,
          stroke: modeFill,
          transition: "fill 0.2s ease-in-out",
        }}
      />
      <rect x="10" y="12" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="13" y="12" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="16" y="12" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="10" y="15" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="13" y="15" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="16" y="15" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="10" y="18" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="13" y="18" width="2" height="2" style={{ fill: modeFill }} />
      <rect x="16" y="18" width="2" height="2" style={{ fill: modeFill }} />
    </svg>
  );
}
